import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";

const PREFIX = "Menu";

const classes = {
  root: `${PREFIX}-root`,
  closeButton: `${PREFIX}-closeButton`,
  mobile: `${PREFIX}-mobile`,
  desktop: `${PREFIX}-desktop`,
  loved: `${PREFIX}-loved`,
  menuButton: `${PREFIX}-menuButton`,
  anchors: `${PREFIX}-anchors`,
  heartAnchor: `${PREFIX}-heartAnchor`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.mobile}`]: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  [`& .${classes.desktop}`]: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },

  [`& .${classes.loved}`]: {
    color: "red",
    height: "16px",
    position: "relative",
    top: "3px",
  },

  [`& .${classes.menuButton}`]: {
    color: "black",
  },

  [`& .${classes.anchors}`]: {
    textDecoration: "none",
    color: theme.palette.primary.dark,
    fontWeight: "bold",
  },

  [`& .${classes.heartAnchor}`]: {
    textDecoration: "none",
    color: "crimson",
    fontWeight: "bold",
  },
}));

const MenuRoot = styled(Menu)(({ theme }) => ({
  [`& .${classes.loved}`]: {
    color: "red",
    height: "16px",
    position: "relative",
    top: "3px",
  },

  [`& .${classes.anchors}`]: {
    textDecoration: "none",
    color: theme.palette.primary.dark,
    fontWeight: "bold",
  },
}));

export default function Links(props) {
  const [anchorEl, setAnchorEl] = useState({
    open: false,
    element: null,
    path: window.location.pathname,
  });

  const handleClick = (event) => {
    setAnchorEl({
      ...anchorEl,
      open: !!event.currentTarget,
      element: event.currentTarget,
    });
  };

  const handleClose = (path) => {
    setAnchorEl({ open: false, element: null, path: path });
  };

  const [open, setOpen] = React.useState(false);

  const handleDialogOpen = () => {
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
  };

  const SignOut = (Action) => {
    if (Action === "ForNow") sessionStorage.clear();
    if (Action === "Forever") {
      sessionStorage.clear();
      localStorage.clear();
    }
    handleDialogClose();
    window.location = `${process.env.PUBLIC_URL}/`;
  };

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleDialogClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  return (
    <Root>
      <Dialog onClose={handleDialogClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleDialogClose}>
          You are about to sign out.
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Choose "For Now" if you plan on returning as the same user in future or "Forever" if you wish sign on as a different
            user or plan on abandoning your current device.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              SignOut("Forever");
            }}
            color="secondary">
            Forever
          </Button>
          <Button
            variant="contained"
            autoFocus
            onClick={() => {
              SignOut("ForNow");
            }}
            color="primary">
            For Now
          </Button>
        </DialogActions>
      </Dialog>
      {/* Mobile First */}
      <Typography className={classes.mobile} edge="end">
        <IconButton
          edge="end"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={handleClick}
          aria-controls="simple-menu"
          aria-haspopup="true">
          <MenuIcon />
        </IconButton>
        <MenuRoot id="simple-menu" anchorEl={anchorEl.element} keepMounted open={Boolean(anchorEl.open)} onClose={handleClose}>
          <MenuItem
            onClick={() => {
              handleClose("/");
            }}>
            <Link to={`${process.env.PUBLIC_URL}/`} className="Menu-anchors">
              Home
            </Link>
          </MenuItem>
          {props.hasLove ? (
            <MenuItem
              onClick={() => {
                handleClose("/hearts");
              }}>
              <Link to={`${process.env.PUBLIC_URL}/hearts`} className={classes.anchors}>
                Favourited
                <FavoriteIcon className={classes.loved} />
              </Link>
            </MenuItem>
          ) : (
            false
          )}
          <MenuItem
            onClick={() => {
              handleClose("/calculate");
            }}>
            <Link to={`${process.env.PUBLIC_URL}/calculate`} className={classes.anchors}>
              Cost Calculator
            </Link>
          </MenuItem>

          {sessionStorage.getItem("authToken") ? (
            [
              <MenuItem
                key={"settings"}
                onClick={() => {
                  handleClose("/settings");
                }}>
                <Link to={`${process.env.PUBLIC_URL}/dashboard`} className={classes.anchors}>
                  Dashboard
                </Link>
              </MenuItem>,
              <MenuItem
                key={"cheers"}
                className={classes.anchors}
                onClick={() => {
                  handleDialogOpen();
                  //SignOut();
                  //handleClose("/");
                }}>
                Sign out
              </MenuItem>,
            ]
          ) : (
            <MenuItem
              onClick={() => {
                handleClose("/settings");
              }}>
              <Link to={`${process.env.PUBLIC_URL}/auth`} className={classes.anchors}>
                Sign in
              </Link>
            </MenuItem>
          )}
        </MenuRoot>
      </Typography>
      {/* Desktop Second */}
      <Typography className={classes.desktop} edge="end">
        <Button
          onClick={() => {
            handleClose("/");
          }}>
          <Link to={`${process.env.PUBLIC_URL}/`} className={classes.anchors}>
            Home
          </Link>
        </Button>
        {/* <Button
          onClick={() => {
            handleClose("/rentals");
          }}
        >
          <Link
            to={`${process.env.PUBLIC_URL}/rentals`}
            className={classes.anchors}
          >
            Rentals
          </Link>
        </Button> */}
        {props.hasLove ? (
          <Button
            onClick={() => {
              handleClose("/hearts");
            }}>
            <Link to={`${process.env.PUBLIC_URL}/hearts`} className={classes.heartAnchor}>
              Favourited
            </Link>
          </Button>
        ) : (
          false
        )}
        <Button
          onClick={() => {
            handleClose("/calculate");
          }}>
          <Link to={`${process.env.PUBLIC_URL}/calculate`} className={classes.anchors}>
            Cost Calculator
          </Link>
        </Button>

        {/* {anchorEl ? (
          anchorEl.path !== "/" ? (
            <Button
              onClick={() => {
                handleClose("/");
              }}
            >
              <Link
                to={`${process.env.PUBLIC_URL}/`}
                className={classes.anchors}
              >
                Home
              </Link>
            </Button>
          ) : (
            false
          )
        ) : (
          false
        )} */}
        {sessionStorage.getItem("authToken") ? (
          <>
            <Button
              onClick={() => {
                handleClose("/settings");
              }}>
              <Link to={`${process.env.PUBLIC_URL}/dashboard`} className={classes.anchors}>
                Dashboard
              </Link>
            </Button>
            <Button
              onClick={() => {
                handleDialogOpen();
                //SignOut();
                //handleClose("/");
              }}>
              Sign out
            </Button>
          </>
        ) : (
          <Button
            onClick={() => {
              handleClose("/settings");
            }}>
            <Link to={`${process.env.PUBLIC_URL}/auth`} className={classes.anchors}>
              Sign in
            </Link>
          </Button>
        )}
      </Typography>
    </Root>
  );
}
